import type { PartialObserver } from 'rxjs'
import { fromEvent } from 'rxjs'
import { filter } from 'rxjs/operators'
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bindKey = (keyName: string, callback: any) =>
  fromEvent<KeyboardEvent>(document.body, 'keydown')
    .pipe(filter(({ key }) => key === keyName))
    .subscribe(callback as PartialObserver<KeyboardEvent>)
